import { Component, OnInit } from '@angular/core';
import { LanguageService } from './services/languageService/language.service';
import { RequestService } from './services/requestService/request.service';
import { UserService } from './services/userService/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})

export class AppComponent implements OnInit {
  constructor(private languageService: LanguageService, private requestService: RequestService, private userService: UserService) { }

  ngOnInit() {
    this.languageService.initLang();

    // Listener which get a new token
    this.requestService.onInvalidToken.subscribe(resp => {
      this.userService.getToken().then(token => { });
    });

    // Listener to hear when the user is unauthorized
    this.requestService.onUnauthorized.subscribe(resp => {
      this.userService.onLogout();
    });
  };
}